import React,{useState} from "react";
import { MenuItem, Menu } from "@material-ui/core";
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Typography from '@material-ui/core/Typography';
import NoteAddIcon from '@material-ui/icons/NoteAdd';
import Divider from '@material-ui/core/Divider';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import IconButton from '@material-ui/core/IconButton';
import GroupWorkIcon from '@material-ui/icons/GroupWork';
import DeleteIcon from '@material-ui/icons/Delete';
import UpdateZone from './UpdateZone'
import EquipesZone from './EquipesZone'
import {connect,useDispatch} from 'react-redux'
import { getZones,deleteZones } from "redux/actions/settingsAction";
import {verifRule} from 'application'
function CustomMenu (props){
  const dispatch =useDispatch()
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [ropen, setRopen] = useState(false)
  const handleRopen =()=>{
    setRopen(true)
    handleClose()
  }
  const handleCloseAdd =()=>{
    setRopen(false)
    handleClose()
  }
  const [eopen, setEopen] = useState(false)
  const handleEopen =()=>{
    setEopen(true)
    handleClose()
  }
  const handleCloseEquipe =()=>{
    setEopen(false)
    handleClose()
  }
  const handleClick = (e) => {
    setAnchorEl(e.currentTarget);
  }

  const handleClose = () => {
    setAnchorEl(null);
  }
  
  
const handleDelete=()=>{
  deleteZones(data.id).then(mrx=>{
    if(mrx){
      dispatch(getZones())
    }
  })
}

  const {data} = props;     
      return(
        <React.Fragment>
         <UpdateZone zoneData={data} ropen={ropen} handleCloseAdd={handleCloseAdd}/>
         <EquipesZone zoneData={data} eopen={eopen} handleCloseEquipe={handleCloseEquipe}/>
          <IconButton
            data-id={data.id}
            aria-label="actions"
            aria-controls='long-menu'
            aria-haspopup="true"
            onClick={handleClick}
          >
            <MoreVertIcon />
          </IconButton>
          <Menu
            id="card-actions-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
           {verifRule('zone','update')&&(<MenuItem onClick={handleRopen}>
              <ListItemIcon>
                  <NoteAddIcon fontSize="small" color='primary' />
              </ListItemIcon>
              <Typography variant="inherit">Modifier</Typography>
            </MenuItem>  )}
            {verifRule('zone','update')&&(<MenuItem disabled>
                <Divider />
            </MenuItem>
            )}
            
              <MenuItem onClick={handleEopen}>
                <ListItemIcon>
                  <GroupWorkIcon fontSize="small" color='primary' />
                </ListItemIcon>
                <Typography variant="inherit">Equipes</Typography>
              </MenuItem>
              {verifRule('zone','delete')&&(
                 <MenuItem disabled>
                 <Divider />
                </MenuItem> 
              )}
           
           
              {verifRule('zone','delete')&&(<MenuItem onClick={handleDelete} >
                <ListItemIcon>
                      <DeleteIcon fontSize="small" color='primary' />
                </ListItemIcon>
                <Typography variant="inherit">Supprimer</Typography>
              </MenuItem>)}
              
          </Menu>
      </React.Fragment>
    );
      
  }
  const mapStateToProps = (state) => ({
    api: state.api,
    user:state.user,
    ui:state.UI
  });
  const mapActionsToProps = {}
  export default connect(mapStateToProps,mapActionsToProps)(CustomMenu)
